import { Table, Dropdown, Tooltip } from "@abel-technologies-as/components";
import { renderColumns } from "./Columns";
import { ExtendedDhcTableProps } from "./DhcTable.types";
import { useState, useEffect } from "react";
import { TableAction } from "@/shared/components";
import { Eye } from "@/shared/icons";
// import { SmallPencil } from "@/shared/icons";
import { useNavigate } from "react-router";
import { Flex } from "@abel-technologies-as/components";
import { Dots } from "@/shared/icons";
import { useTranslation } from "react-i18next";

const DhcsTable = ({
	url = "dhcs",
	visibleColumns,
	onSelectionChange,
	clearSelection,
	rows,
	loading,
	totalPages,
	totalItems,
	currentPage,
	onPageChange,
}: ExtendedDhcTableProps) => {
	const { t } = useTranslation("dhc");
	const navigate = useNavigate();
	const [ids, setIds] = useState<Array<number | string>>([]);
	const [internalPage, setInternalPage] = useState<number>(1);
	const [currentDropDownId, setCurrentDropDownId] = useState<number>(0);
	const [openDropDown, setOpenDropDown] = useState<boolean>(false);

	const defaultColumns = renderColumns({ url, t });
	const columns = visibleColumns ? defaultColumns.filter((col) => visibleColumns.includes(col.field)) : defaultColumns;

	const handleOnMouseLeave = () => {
		setOpenDropDown(false);
		setCurrentDropDownId(0);
	};

	const handleOnClickOption = (id: number) => {
		setCurrentDropDownId(id);
		setOpenDropDown(!openDropDown);
	};

	const handleSelectionChange = (newIds: Array<number | string>) => {
		setIds(newIds);
		if (onSelectionChange) {
			onSelectionChange(newIds);
		}
	};

	const page = typeof currentPage === "number" ? currentPage : internalPage;
	const handlePageChange = (newPage: number) => {
		if (onPageChange) {
			onPageChange(newPage);
			return;
		}
		setInternalPage(newPage);
	};

	useEffect(() => {
		if (clearSelection) {
			setIds([]);
			if (onSelectionChange) {
				onSelectionChange([]);
			}
		}
	}, [clearSelection, onSelectionChange]);

	return (
		<>
			<Table
				key={visibleColumns?.join(",")}
				includeActions
				checkboxSelection={true}
				totalItems={totalItems}
				cellPaddingTopBottom={"13px"}
				loading={loading}
				renderActionSection={(row) => (
					<TableAction
						onMouseLeave={handleOnMouseLeave}
						actions={[
							{
								id: "view",
								onClick: () => navigate(`/dhcs/${row.id}`),
								icon: (
									<Tooltip content={t("view_dhc_details")} position="top">
										<Eye width="20" height="20" />
									</Tooltip>
								),
							},
							// {
							// 	id: "approve",
							// 	onClick: () => handleApprove(),
							// 	icon: (
							// 		<Tooltip content="Approve payout" position="top">
							// 			<ApprovePayout width="15" height="15" />
							// 		</Tooltip>
							// 	),
							// },
							// {
							// 	id: "edit",
							// 	onClick: () => null,
							// 	icon: (
							// 		<Tooltip content="Edit DHC" position="top">
							// 			<SmallPencil width="15" height="15" />
							// 		</Tooltip>
							// 	),
							// },
							{
								id: "option",
								onClick: () => handleOnClickOption(Number(row.id)),
								icon:
									currentDropDownId === row.id ? (
										<Dropdown
											setOpenDropDown={setOpenDropDown}
											openDropDown={openDropDown}
											position="bottom"
											customDropDownContent={null}
											triggerComponent={
												<Flex>
													<Dots width="15" height="15" />
												</Flex>
											}></Dropdown>
									) : (
										<Dots width="15" height="15" />
									),
							},
						]}
					/>
				)}
				ids={ids}
				setIds={handleSelectionChange}
				currentPage={page}
				totalPages={totalPages ?? 30}
				onPageChange={handlePageChange}
				columns={columns}
				rows={rows ?? []}
			/>
		</>
	);
};

export { DhcsTable };
